```vue
<template>
  <div :class="['toolbar-container', $mq]" v-bind:style="toolbarStyle">
    <div :class="['text-container', $mq]">
      <div class="logo-container">
        <img :src="`${clientResourcesUrl}logo.png?alt=media`" alt="App Logo" class="app-logo">
      </div>      

      <div class="text">
        <h1 class="title is-4">{{ verbiage.outline_areas_title }}</h1>
        <p v-html="verbiage.outline_areas_paragraph"></p>
      </div>
    </div>
    
    <div :class="['controls', $mq]">      
      <b-button expanded @click="handleBackClick" class="prev-button">
        <arrow-left-icon />
        BACK
      </b-button>
    
    
      <b-button expanded type="is-primary" @click="handleFinishClick">
        <check-icon />
        FINISH
      </b-button>       
    </div>
  </div>
</template>

<style scoped>
  .toolbar-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-shadow: 0px 3px 6px var(--app-toolbar-shadow);
    padding: .8em;
    background-color: var(--app-toolbar-bg);
    color: var(--app-text);

    display: flex;
    flex-wrap: wrap;
  }

  div.text-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-grow: 1;
  }

  div.controls {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-grow: 1;
    padding-left: 10px;    
    justify-content: flex-end;
  }

  div.controls button {
    margin: 2px 5px;
    max-width: 200px;
  }

  /* Side-by-side buttons on all screen sizes */
  div.controls.lg, div.controls.md, div.controls.sm, div.controls.xs {
    flex-direction: row;
  }

  /* Mobile: smaller gap and full width buttons */
  div.toolbar-container.xs div.controls {
    width: 100%;
    gap: 0.5rem;
  }

  div.toolbar-container.xs div.controls button {
    max-width: none;
    flex: 1;
    margin: 0;
  }

  div.logo-container {
    padding: 5px 5px 0;
  }
   
  .app-logo {
    max-width: 100px;
  }  

  div.toolbar-container.xs div.logo-container {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  div.toolbar-container.xs div.logo-container .app-logo {
    max-width: 80px;
  }

  h1.title {
    margin-bottom: 0;
  }

  div.toolbar-container.xs h1.title {
    font-size: 1.3em;
    padding-bottom: 5px;
  }  

</style>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { useDialogsStore } from '@/stores/dialogs'
import { useContactStore } from '@/stores/contact'
import { useConfig } from '@/composables/useConfig'

export default {
  setup() {
    const router = useRouter()
    const mainStore = useMainStore()
    const dialogsStore = useDialogsStore()
    const contactStore = useContactStore()
    const { verbiage, clientResourcesUrl } = useConfig()

    // Computed
    const shapes = computed(() => mainStore.shapesWithConversions)
    const hide = computed(() => mainStore.mapDrag)

    const toolbarStyle = computed(() => ({
      opacity: hide.value ? 0 : 1,
      visibility: hide.value ? 'hidden' : 'visible',
      transition: 'opacity 0.5s ease, visibility 0.5s ease'
    }))

    // Methods
    const handleBackClick = () => {
      if (shapes.value.length === 0) {
        router.push('/flow/confirm-address')
        return
      }

      dialogsStore.confirm(0, `Going back will remove all measurement layers from the map. <br><br><span class="has-text-weight-bold">Are you sure?</span>`, {
        title: 'Warning',
        confirmText: 'Yes, go back',
        cancelText: 'Cancel',
        type: 'is-primary',
        onConfirm: async () => {
          await mainStore.clearShapes()
          contactStore.resetState()

          router.push('/flow/confirm-address')
        }
      })
    }

    const handleFinishClick = async () => {
      if (shapes.value.length === 0) {
        dialogsStore.alert(1, 'Please add at least one measurement area to proceed.', {
          title: 'No Measurement Areas'
        })
      } else {
        router.push('/flow/get-measurements')
      }
    }

    return {
      shapes,
      hide,
      toolbarStyle,
      verbiage,
      clientResourcesUrl,
      handleBackClick,
      handleFinishClick
    }
  }
}
</script>